import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import { OpenAPI } from "../../gen/clients/llts";
import { getBranchIdFromPathname, resolveApiBaseUrl } from "../../utils/apiBaseUrl";

/**
 * Keeps OpenAPI.BASE in sync with the lltsBranchId from the URL.
 *
 * When the URL points to a UK branch (uk, en-gb, en-GB), API calls are routed to
 * VITE_API_URL_OVERRIDE_UK; otherwise to VITE_API_URL_OVERRIDE. The react-query
 * cache is cleared whenever the resolved base URL actually changes so cached data
 * from one API is not served against the other.
 *
 * This component renders nothing and only performs side effects.
 */
const ApiBaseUrlManager: React.FC = () => {
  const location = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    const branchId = getBranchIdFromPathname(location.pathname);
    const nextBase = resolveApiBaseUrl(branchId);
    if (nextBase && nextBase !== OpenAPI.BASE) {
      OpenAPI.BASE = nextBase;
      queryClient.clear();
    }
  }, [location.pathname, queryClient]);

  return null;
};

export default ApiBaseUrlManager;
